import { NgModule } from '@angular/core';
import { VerticalLayoutModule } from 'app/layout/vertical/vertical-layout.module';
import { HorizontalLayoutModule } from 'app/layout/horizontal/horizontal-layout.module';
import { HomeLayoutModule } from 'app/layout/home/home-layout.module';

@NgModule({
  imports: [VerticalLayoutModule, HorizontalLayoutModule, HomeLayoutModule],
  exports: [VerticalLayoutModule, HorizontalLayoutModule, HomeLayoutModule]
})
export class LayoutModule {}